<template>
    <div class="button-block">


        <div class="button-display mb-2">
            <a :href="block.url || '#'" :style="buttonStyles" class="button-link" @click.prevent="handleClick">
                {{ block.text || 'Cliquez ici' }}
            </a>
        </div>

        <div class="button-editor">
            <v-text-field v-model="localText" label="Texte du bouton" @blur="updateButton" dense hide-details />

            <v-text-field v-model="localUrl" label="URL de destination" placeholder="https://example.com"
                @blur="updateButton" dense hide-details class="mt-2" />

            <div class="style-controls mt-3">
                <v-row class="align-center">
                    <v-col cols="12" md="3">
                        <v-text-field v-model="localBackgroundColor" label="Fond" type="color" dense variant="outlined"
                            hide-details />
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field v-model="localColor" label="Texte" type="color" dense variant="outlined"
                            hide-details />
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-btn-toggle :model-value="block.styles?.alignment || 'center'"
                            @update:model-value="updateAlignment">
                            <v-btn value="left" size="small" variant="outlined">
                                <v-icon>mdi-format-align-left</v-icon>
                                <v-tooltip activator="parent" location="top">Gauche</v-tooltip>
                            </v-btn>
                            <v-btn value="center" size="small" variant="outlined">
                                <v-icon>mdi-format-align-center</v-icon>
                                <v-tooltip activator="parent" location="top">Centre</v-tooltip>
                            </v-btn>
                            <v-btn value="right" size="small" variant="outlined">
                                <v-icon>mdi-format-align-right</v-icon>
                                <v-tooltip activator="parent" location="top">Droite</v-tooltip>
                            </v-btn>
                        </v-btn-toggle>
                    </v-col>
                </v-row>

            </div>
        </div>


    </div>
</template>

<script>
export default {
    name: 'ButtonBlock',
    props: {
        block: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEditing: false,
            localText: '',
            localUrl: '',
            localBackgroundColor: '',
            localColor: ''
        }
    },
    computed: {
        buttonStyles() {
            return {
                backgroundColor: this.block.styles?.backgroundColor || '#007bff',
                color: this.block.styles?.color || '#ffffff',
                padding: this.block.styles?.padding || '12px 24px',
                borderRadius: this.block.styles?.borderRadius || '4px',
                textDecoration: 'none',
                display: 'inline-block',
                fontSize: this.block.styles?.fontSize || '16px',
                fontWeight: this.block.styles?.fontWeight || '500',
                textAlign: 'center',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.2s ease'
            }
        }
    },
    mounted() {
        this.localText = this.block.text || 'Cliquez ici'
        this.localUrl = this.block.url || '#'
        this.localBackgroundColor = this.block.styles?.backgroundColor || '#007bff'
        this.localColor = this.block.styles?.color || '#ffffff'
    },
    watch: {
        localBackgroundColor(newValue) {
            console.log('localBackgroundColor changed', newValue)
            this.$emit('update', {
                styles: { ...this.block.styles, backgroundColor: newValue }
            })
        },
        localColor(newValue) {
            console.log('localColor changed', newValue)
            this.$emit('update', {
                styles: { ...this.block.styles, color: newValue }
            })
        }
    },
    methods: {
        startEditing() {
            this.isEditing = true
            this.localText = this.block.text || 'Cliquez ici'
            this.localUrl = this.block.url || '#'
        },

        updateButton() {
            this.isEditing = false
            this.$emit('update', {
                text: this.localText,
                url: this.localUrl
            })
        },

        updateStyles() {
            this.$emit('update', {
                styles: { ...this.block.styles }
            })
        },

        handleClick(event) {
            if (this.block.url && this.block.url !== '#') {
                // En mode édition, ne pas suivre le lien
                if (this.isEditing) {
                    event.preventDefault()
                }
            } else {
                event.preventDefault()
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.button-block {
    text-align: center;
    padding: 16px;
    border: 1px solid transparent;
    border-radius: 4px;
    transition: all 0.2s;

    &:hover {
        border-color: #e0e0e0;
    }
}

.block-header {
    display: flex;
    justify-content: flex-end;
    padding: 4px 8px;
    background: #f5f5f5;
    border-radius: 4px 4px 0 0;
    opacity: 0;
    transition: opacity 0.2s;

    .button-block:hover & {
        opacity: 1;
    }
}

.properties-toolbar {
    background: #f8f9fa;
    padding: 12px;
    border-bottom: 1px solid #e0e0e0;

    .v-text-field {
        margin-bottom: 0;
    }
}



.button-display {
    cursor: pointer;


}

.button-link {
    text-decoration: none !important;
    display: inline-block;
    transition: all 0.2s ease;
}
</style>
